/* eslint-disable no-cond-assign */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/style-prop-object */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable eqeqeq */
import { Field, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Card, Form, Button, InputGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as actionsPosts from "../../../../redux/actions/posts";
import "react-mde/lib/styles/css/react-mde-all.css";
import { Route, Switch } from "react-router-dom";
import * as Yup from "yup";
import { fetchImageToken } from "../../../../redux/actions/imageAuth";
import PollCreatorDialog from "../RestlessArticlesEditor/PollCreatorDialog";
import { Alert } from "react-bootstrap";
import "./RestlessPostEditor";
import SchedulePostDialog from "./SchedulePostDialog";
import { postsSlice } from "../../../../redux/actions/posts/postsSlice";
import SelectGif from "./SelectGif";
import {
  HASHTAG_REGEX,
  MENTION_REGEX,
  replaceAt,
} from "../../../components/utils";
import { fetchHashtagsByKeyword } from "../../../../redux/actions/hashtags";
import "./style.css";
import { fetchMentions } from "../../../../redux/actions/users";
import { peoplePlaceHolder } from "../../../components/imageUserDefault";
import SVG from "react-inlinesvg";
import { Image } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import Picker from "emoji-picker-react";
import SubmitPostDialog from "./SubmitPostDialog";
import { format } from "date-fns";
import { enGB, srLatn } from "date-fns/locale";
import { getGifById } from "../../../components/GIPHY";

const { actions } = postsSlice;

export default function RestlessPostEditorPage({ history, match }) {
  const dispatch = useDispatch();
  const [errorMessage, setErrorMessage] = useState("");
  const [schedule, setSchedule] = useState();
  const [extraVideo, setExtraVideo] = useState(null);
  const [extraImage, setExtraImage] = useState([]);
  const [extraGif, setExtraGif] = useState();
  const [dateLabel, setDateLabel] = useState();
  const [dateLabelLocal, setDateLabelLocal] = useState();
  const [dateLabelUTC, setDateLabelUTC] = useState();
  const [datePostToSend, setDatePostToSend] = useState();
  const [postBody, setPostBody] = useState("");
  const [contentSearch, setContentSearch] = useState();
  const [inputSelection, setInputSelection] = useState({ start: 0, end: 0 });
  const [writingMention, setWritingMention] = useState(false);
  const [mentions, setMentions] = useState([]);
  const [isAddMode, setisAddMode] = useState();
  const [pinnedPost, setPinnedPost] = useState(false);
  const [mentionInProgress, setMentionInProgress] = useState("");
  const { id } = match.params;
  const MAX_MARKDOWN_CHARACTERS_POST = 2500;
  const MAX_MARKDOWN_CHARACTERS_POLL = 1500;
  const MAX_MARKDOWN_CHARACTERS_NOTIFICATION = 150;
  const mediaType = ["None", "Images", "Video", "Gif", "Poll"];
  const [chosenEmojiNotif, setChosenEmojiNotif] = useState(null);
  const refPickerEmojiNotif = useRef();
  const [showNotif, setShowNotif] = useState(false);
  const [chosenEmoji, setChosenEmoji] = useState(null);
  const refPickerEmoji = useRef();
  const [show, setShow] = useState(false);
  const [postToEdited, setPostToEdited] = useState(false);
  const [dataToPost, setDataToPost] = useState();
  const [submitting,setSubmitting] = useState(false);

  const initialValues = {
    content: "",
    category: "",
    mediaContent: "",
    custonnotification: "",
  };

  const {
    categoriesList,
    poll,
    imageToken,
    error,
    suggestedHashtags,
    suggestedPeople,
    newPost,
    fetchPost,
    postDraftEdited,
    drafPost,
  } = useSelector((state) => ({
    categoriesList: state.posts.categoriesList,
    poll: state.posts.poll,
    imageToken: state.imageAuth.imageToken,
    error: state.posts.error,
    suggestedHashtags: state.hashtags.hashtagsList,
    suggestedPeople: state.users2.usersList || [],
    newPost: state.posts.newPost,
    fetchPost: state.posts.fetchPost,
    postDraftEdited: state.posts.postDraftEdited,
    drafPost: state.posts.drafPost,
  }));

  useEffect(() => {
    dispatch(actionsPosts.fetchDraftPosts());
    dispatch(actionsPosts.fetchCategories());
    dispatch(fetchImageToken());
    if (id) actionsPosts.getPostById(id, dispatch);
  }, []);

  useEffect(() => {
    searchForHashtags(contentSearch);
    searchForMentions(contentSearch);
  }, [contentSearch]);

  useEffect(() => {
    setisAddMode(!id);
  }, [id, isAddMode]);

  useEffect(() => {
    if (schedule) {
      const today = new Date();
      const dataArray = schedule.date.split("-");
      let dateSchedule;

      // AM or PM
      if (schedule.time === "AM") {
        dateSchedule = new Date(
          dataArray[0],
          dataArray[1] - 1,
          dataArray[2],
          schedule.hours,
          schedule.minutes,
          0
        );
      } else {
        let hours;
        if (schedule.hours === 0) {
          hours = 12;
        } else {
          hours = parseInt(schedule.hours) + 12;
        }
        dateSchedule = new Date(
          dataArray[0],
          dataArray[1] - 1,
          dataArray[2],
          hours,
          schedule.minutes,
          0
        );
      }

      const dataEST = new Date(
        dateSchedule.toLocaleString("en-US", { timeZone: "America/New_York" })
      );
      setDateLabelLocal(dataEST.toString().substr(0, 24) + " EST");
      setDateLabelUTC(dateSchedule.toUTCString());
      const labelDateScheduled = format(dateSchedule, "dd/MM/yyyy HH:mm");
      setDateLabel(labelDateScheduled + " " + schedule.time);
      setDatePostToSend(dateSchedule);
    } else {
      if (fetchPost) {
        let dateSchedule = new Date(fetchPost.scheduled_dt);

        const dataEST = new Date(
          dateSchedule.toLocaleString("en-US", { timeZone: "America/New_York" })
        );
        setDateLabelLocal(dataEST.toString().substr(0, 24) + "EST");
        setDateLabelUTC(dateSchedule.toUTCString());
        const labelDateScheduled = format(dateSchedule, "dd/MM/yyyy HH:mm");
        setDateLabel(labelDateScheduled);
        setDatePostToSend(new Date(fetchPost.scheduled_dt));
      }
    }
  }, [schedule, fetchPost]);

  const PostSchema = Yup.object().shape({
    content: Yup.string().max(
      poll ? MAX_MARKDOWN_CHARACTERS_POLL : MAX_MARKDOWN_CHARACTERS_POST,
      "Maximun" +
        (poll ? MAX_MARKDOWN_CHARACTERS_POLL : MAX_MARKDOWN_CHARACTERS_POST) +
        "characters per post"
    ),
    category: Yup.string().required("Category is a required field"),
    mediaContent: Yup.string(),
  });

  const postsUIEvents = {
    openPollCreatorDialog: () => {
      history.push({
        pathname: fetchPost ? `/posts/editor/${id}/poll` : "/posts/new/poll",
        state: { poll: poll },
      });
    },
    openSchedulePostDialog: () => {
      history.push({
        pathname: fetchPost
          ? `/posts/editor/${id}/schedule`
          : "/posts/new/schedule",
      });
    },
    openSelecGifDialog: () => {
      history.push({
        pathname: fetchPost
          ? `/posts/editor/${id}/selectgif`
          : "/posts/new/selectgif",
      });
    },
    openSubmitPostDialog: () => {
      history.push({
        pathname: fetchPost
          ? `/posts/editor/${id}/submit`
          : "/posts/new/submit",
      });
    },
  };

  useEffect(() => {
    if (newPost || postDraftEdited) {
      history.push("/posts");
    }
  }, [newPost, postDraftEdited]);

  const onExtraImageChange = (e) => {
    if(e.target.files.length){
      if (extraImage?.length >= 10) {
        setErrorMessage("A maximum of 10 images is allowed");
        return;
      }
      setExtraImage([...extraImage, e.target.files[0]]);
    }    

  };

  const searchForMentions = (value) => {
    let lastWord = "";
    const indexSelection = inputSelection.end;
    const mentionsinBody = value?.match(MENTION_REGEX);
    const mentionsArray = mentionsinBody?.map((item) => {
      const index = indexSelection - item.length;
      const itemCompare = value.substr(index, item.length);
      if (item === itemCompare) {
        lastWord = item;
      }
    });
    if (MENTION_REGEX.test(lastWord) || writingMention) {
      if (writingMention) {
        let indexFrom = 0;
        if (mentions.length > 0) {
          const lastsMentions = mentions
            .filter((e) => e.endAt < indexSelection)
            .sort((itemA, itemB) => itemA.endAt - itemB.endAt);
          indexFrom =
            lastsMentions.length > 0
              ? lastsMentions[lastsMentions.length - 1].endAt
              : 0;
        }
        const index = value.indexOf(lastWord, indexFrom);
        lastWord = value.substr(index, indexSelection - index);
      }
      setPeopleSuggestor(lastWord);
    }
  };

  const setPeopleSuggestor = (keyword) => {
    fetchMentions(keyword.replace("@", ""), dispatch);
    setMentionInProgress(keyword);
  };

  const onExtraVideoChange = (e) => {
    setExtraVideo(e.target.files[0]);
  };

  const validationSubmit = (values) => { 
    setSubmitting(true);
    if ((values.content == "" || !values.content) && !poll) {
      setErrorMessage("You can't create empty post");
      setSubmitting(false);
      return;
    }

    const formData = new FormData();
    if (extraVideo) formData.append("files", extraVideo);
    if (extraImage?.length > 0) {
      extraImage.map((imageFile) => formData.append("files", imageFile));
    }

    formData.append(
      "post",
      JSON.stringify({
        body: !poll ? values.content : "",
        categoryId: parseInt(values.category),
        gif_id: extraGif ? extraGif?.id : null,
        anonymous: values.anonymous,
        poll: poll
          ? {
              ...poll,
              options: poll.options.map((option) => option.value),
            }
          : null,
        pinned: pinnedPost,
        scheduled_dt:
          datePostToSend && !fetchPost?.published_at ? datePostToSend : null,
        notification_body:
          !fetchPost?.published_at && values.custonnotification.trim() !== ""
            ? values.custonnotification
            : null,
        is_backoffice: false,
        is_public: true
      })
    );
    setDataToPost(formData);
    postsUIEvents.openSubmitPostDialog();
  };

  const onSubmit = (data) => {
    if (isAddMode) {
      dispatch(actionsPosts.createPost(data));
    } else {
      dispatch(actionsPosts.updatedDrafPost(data, id));
    }
  };

  const onEmojiClick = (event, emojiObject) => {
    setChosenEmoji(emojiObject);
  };
  const onEmojiClickNotif = (event, emojiObject) => {
    setChosenEmojiNotif(emojiObject);
  };

  const renderPostError = (error) => {
    return (
      <Alert
        variant="danger"
        className="text-center"
        dismissible
        onClose={() => setErrorMessage()}
      >
        {error}
      </Alert>
    );
  };

  const deleteImage = (index) => {
    const dataImage = new Array(...extraImage);
    if (index) {
      dataImage.splice(index, 1);
    } else {
      dataImage.pop();
    }
    setExtraImage(dataImage);
  };

  const showImagePreview = (data) => {
    return (
      <>
        <div className="d-flex justify-content-center flex-wrap">
          {data?.map(
            (file, index) =>
              file && (
                <div                 
                className="mr-2 mt-2" 
                key={index} >
                  {fetchPost ? (
                    <img
                      src={file.url + imageToken}
                      width="45"
                      height="45"
                      onClick={() => deleteImage(index)}
                    />
                  ) : (
                    <img
                      src={URL.createObjectURL(file)}
                      width="45"
                      height="45"
                      onClick={() => deleteImage(index)}
                    />
                  )}
                </div>
              )
          )}
        </div>
        <div className="d-flex justify-content-center mt-2 mb-2">
          <Button onClick={() => deleteImage()}>Remove</Button>
        </div>
      </>
    );
  };

  const showVideoPreview = (data) => {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center mb-2">
        <div className="mr-2">
          <video controls width="250">
            {fetchPost && data?.url ? (
              <source src={data.url + imageToken} />
            ) : (
              <source src={URL.createObjectURL(data)} />
            )}
          </video>
        </div>
        <Button onClick={() => setExtraVideo()}>Remove</Button>
      </div>
    );
  };

  const onDeleteGif = () => {
    setExtraGif();
  };

  const [showHashtag, setShowHashtag] = useState(false);

  const setHashtagSuggestor = (keyword) => {
    fetchHashtagsByKeyword(keyword, dispatch);
    setShowHashtag(true);
  };

  const onPressHashtag = (hashtag) => {
    const hashtags = contentSearch.match(HASHTAG_REGEX);
    let hashtagToReplace = "";
    const array = hashtags?.map((item) => {
      const itemCompare = contentSearch.slice(
        inputSelection.end - item.length,
        inputSelection.end
      );
      if (itemCompare === item) {
        hashtagToReplace = item;
      }
    });

    const index = inputSelection.end - hashtagToReplace.length;
    let newBody = replaceAt(contentSearch, index, hashtag, hashtagToReplace);
    if (
      newBody.length >
      (poll ? MAX_MARKDOWN_CHARACTERS_POLL : MAX_MARKDOWN_CHARACTERS_POST)
    ) {
      setErrorMessage(
        "Maximun" +
          (poll ? MAX_MARKDOWN_CHARACTERS_POLL : MAX_MARKDOWN_CHARACTERS_POST) +
          "characters per post"
      );
    }
    setPostBody(newBody);
    setShowHashtag(false);
  };

  const onPressMentions = (mention) => {
    let index = inputSelection.end - mentionInProgress.length;
    setMentionInProgress("");
    setWritingMention(false);
    const mentionTemp = "@" + mention.full_name;
    let newBody = replaceAt(
      contentSearch,
      index,
      mentionTemp + " ",
      mentionInProgress
    );
    if (
      newBody.length >
      (poll ? MAX_MARKDOWN_CHARACTERS_POLL : MAX_MARKDOWN_CHARACTERS_POST)
    ) {
      setErrorMessage(
        "Maximun" +
          (poll ? MAX_MARKDOWN_CHARACTERS_POLL : MAX_MARKDOWN_CHARACTERS_POST) +
          "characters per post"
      );
      newBody = replaceAt(postBody, index, "", mentionTemp);
      setPostBody(newBody);
      setMentionInProgress("");
      setWritingMention(false);
      return;
    }
    const newMention = {
      id: mention.id,
      fullName: mentionTemp,
      startAt: index,
      endAt: index + mentionTemp.length,
    };
    setMentions([...mentions, newMention]);
    setInputSelection({ end: newMention.endAt });
    setPostBody(newBody);
  };

  const renderHashtag = (item) => {
    return (
      <div key={item.id} className="mr-2 mt-2">
        <Button onClick={() => onPressHashtag(item.hashtag)}>
          <span uppercase={false}>{item.hashtag}</span>
        </Button>
      </div>
    );
  };

  const renderMentions = (item) => {
    return (
      <div
        key={item.id}
        className="mr-2 mt-2"
        style={{
          height: "20px",
        }}
      >
        <Button onClick={() => onPressMentions(item)}>
          <div className="d-flex flex-nowrap justify-content-around align-items-center">
            {item.picture && (
              <Image
                className="mr-2 mt-2"
                alt="error"
                style={{
                  height: "20px",
                  width: "20px",
                  marginRight: 6,
                }}
                src={item.picture.url + imageToken}
              />
            )}
            {!item.picture && (
              <span className="svg-icon svg-icon-md">
                <SVG height="45" src={peoplePlaceHolder} />
              </span>
            )}
            <span uppercase={false} className="nowrap">
              {item.full_name}
            </span>
          </div>
        </Button>
      </div>
    );
  };

  const hashtagSuggestion = (
    <div
      className="d-flex justify-content-center align-items-center row mb-2"
      className="scroll"
      style={{
        height: "70px",
        display: "flex",
        flexWrap: "nowrap",
        overflowX: "auto",
        width: "95%",
      }}
    >
      {suggestedHashtags.map((item, index) => {
        return (
          <div keyExtractor={(item, index) => index.toString()}>
            {renderHashtag(item)}
          </div>
        );
      })}
    </div>
  );

  const mentionsSuggestions = (
    <div
      className="d-flex justify-content-center align-items-center row mb-2"
      className="scroll"
      style={{
        height: "70px",
        display: "flex",
        flexWrap: "nowrap",
        overflowX: "auto",
        width: "95%",
      }}
    >
      {suggestedPeople.map((item, index) => {
        return (
          <div keyExtractor={(item, index) => index.toString()}>
            {renderMentions(item)}
          </div>
        );
      })}
    </div>
  );

  useEffect(() => {
    if (suggestedPeople.length > 0) {
      const index = suggestedPeople.find((i) =>
        i.full_name
          .toLowerCase()
          .includes(mentionInProgress.replace("@", "").toLowerCase())
      );
      if (index !== undefined && mentionInProgress !== "") {
        setWritingMention(true);
      } else {
        setWritingMention(false);
      }
    }
  }, [mentionInProgress, suggestedPeople]);

  const searchForHashtags = (value) => {
    const hashtags = value?.match(HASHTAG_REGEX);
    let lastWord = "";
    const indexSelection = inputSelection.end;
    const array = hashtags?.map((item) => {
      const index = indexSelection - item.length;
      const itemCompare = value.substr(index, item.length);
      if (item === itemCompare) {
        lastWord = item;
      }
    });
    if (HASHTAG_REGEX.test(lastWord)) {
      setHashtagSuggestor(lastWord.replace("#", ""));
    } else {
      setShowHashtag(false);
    }
  };

  const onPressCancel = () => {
    history.push("/posts");
    if (fetchPost) {
      dispatch(actions.getPost({ fetchPost: null }));
    }
  };

  return (
    <>
      <Switch>
        <Route
          path={fetchPost ? `/posts/editor/${id}/poll` : "/posts/new/poll"}
        >
          {({ history, match }) => (
            <PollCreatorDialog
              show={match != null}
              id={match && match.params.id}
              poll={history.location.state?.poll}
              entity="Post"
              editPost={fetchPost}
              onHide={() => {
                history.goBack();
              }}
            />
          )}
        </Route>
        <Route
          path={
            fetchPost ? `/posts/editor/${id}/schedule` : "/posts/new/schedule"
          }
        >
          {({ history, match }) => (
            <SchedulePostDialog
              show={match != null}
              id={match && match.params.id}
              drafPost={drafPost}
              schedule={schedule}
              setSchedule={(data) => setSchedule(data)}
              onHide={() => {
                history.goBack();
              }}
            />
          )}
        </Route>
        <Route
          path={
            fetchPost ? `/posts/editor/${id}/selectgif` : "/posts/new/selectgif"
          }
        >
          {({ history, match }) => (
            <SelectGif
              show={match != null}
              id={match && match.params.id}
              setExtraGif={(data) => setExtraGif(data)}
              extraGif={extraGif}
              onHide={() => {
                history.goBack();
              }}
            />
          )}
        </Route>
        <Route
          path={fetchPost ? `/posts/editor/${id}/submit` : "/posts/new/submit"}
        >
          {({ history, match }) => (
            <SubmitPostDialog
              show={match != null}
              id={match && match.params.id}
              post={dataToPost}
              editPost={fetchPost}
              schedule={!fetchPost?.published_at ? schedule : null}
              dataschedule={!fetchPost?.published_at ? datePostToSend : null}
              handleSubmit={onSubmit}
              dateLabelLocal={!fetchPost?.published_at ? dateLabelLocal : null}
              dateLabelUTC={!fetchPost?.published_at ? dateLabelUTC : null}
              onHide={() => {
                setSubmitting(false);
                history.goBack();
              }}
            />
          )}
        </Route>
      </Switch>
      <Formik
        initialValues={initialValues}
        validationSchema={PostSchema}
        onSubmit={validationSubmit}
      >
        {function Render({
          values,
          errors,
          touched,
          status,
          handleChange,
          handleSubmit,
          setFieldValue,
          getFieldProps,
        }) {
          useEffect(() => {
            setContentSearch(values.content);
          }, [values.content]);

          useEffect(() => {
            if (fetchPost) {
              setPostToEdited(true);
              setPinnedPost(fetchPost.pinned);
              setFieldValue("content", fetchPost.body);
              setFieldValue("category", fetchPost.category?.id);
              if (fetchPost.video) {
                setExtraVideo(fetchPost.video);
                setFieldValue("mediaContent", "Video");
              }
              if (fetchPost.gif_id) {
                getGifById(fetchPost.gif_id).then((response) => {
                  setExtraGif(response);
                  setFieldValue("mediaContent", "Gif");
                });
              }
              if (fetchPost.picture_images.length > 0) {
                setExtraImage(fetchPost.picture_images);
                setFieldValue("mediaContent", "Images");
              }
              if (fetchPost.poll) {
                setFieldValue("mediaContent", "Poll");
                setFieldValue("content", fetchPost.poll.body);
                dispatch(actions.postPollCreated({ poll: fetchPost.poll }));
              }
              if (fetchPost.scheduled_notification) {
                setFieldValue(
                  "custonnotification",
                  fetchPost.scheduled_notification.body
                );
              }
            }
          }, [fetchPost]);

          useEffect(() => {
            setFieldValue("content", postBody);
          }, [postBody]);

          useEffect(() => {
            if (!postToEdited) {
              setExtraGif();
              setExtraImage([]);
              setExtraVideo();
              dispatch(actions.postPollCreated({ poll: undefined }));
            } else {
              setPostToEdited(false);
            }
          }, [values.mediaContent]);

          useEffect(() => {
            if (chosenEmoji) {
              setFieldValue("content", values.content + chosenEmoji.emoji);
            }
          }, [chosenEmoji]);
          useEffect(() => {
            if (chosenEmojiNotif) {
              setFieldValue(
                "custonnotification",
                values.custonnotification + chosenEmojiNotif.emoji
              );
            }
          }, [chosenEmojiNotif]);

          return (
            <>
              {(error || errorMessage) &&
                renderPostError(error || errorMessage)}
              <Form onSubmit={validationSubmit}>
                {status ? (
                  <div className="mb-10 justify-content-center alert alert-custom alert-light-danger alert-dismissible">
                    <div className="alert-text font-weight-bold text-center">
                      {status}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="d-flex">
                  <div className="w-75">
                    <Card>
                      <Card.Body>
                        <Form.Group controlId="formArticle">
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <Form.Label>Post Content</Form.Label>
                            <div className="d-flex justify-content-between align-items-center">
                              <div className="d-flex justify-content-between mb-2">
                                <div className="EmojiPicker mt-3 mr-4">
                                  <span
                                    onClick={() => setShow(!show)}
                                    className="svg-icon"
                                  >
                                    <SVG
                                      height="40"
                                      src={toAbsoluteUrl(
                                        "/media/svg/Emoticon.svg"
                                      )}
                                    />
                                  </span>
                                  {show && (
                                    <div
                                      onMouseLeave={() => {
                                        if (show) {
                                          setShow(false);
                                        }
                                      }}
                                      ref={refPickerEmoji}
                                      className="EmojiPicker__Wrapper"
                                    >
                                      <Picker
                                        onEmojiClick={onEmojiClick}
                                        native
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                              <div className="ml-2">
                                <Button
                                  variant="primary"
                                  onClick={() => onPressCancel()}
                                  type="submit"
                                >
                                  Cancel
                                </Button>
                              </div>
                              <div className="ml-2">
                                <Button
                                  variant="primary"
                                  onClick={handleSubmit}
                                  type="submit"
                                  disabled={submitting}
                                >
                                  Submit
                                  {submitting && (
                                    <span className="mx-3 spinner spinner-white"></span>
                                  )}
                                </Button>
                              </div>
                            </div>
                          </div>
                          <textarea
                            style={{ width: "100%", height: 300, padding: 10 }}
                            className="border"
                            autoFocus="autofocus"
                            type="text"
                            maxLength={
                              poll
                                ? MAX_MARKDOWN_CHARACTERS_POLL
                                : MAX_MARKDOWN_CHARACTERS_POST
                            }
                            disabled={poll}
                            placeholder="Here goes the content of your post"
                            value={poll ? poll.body : values.content}
                            onChange={(e) => {
                              setFieldValue("content", e.target.value);
                              setInputSelection({
                                start: 0,
                                end: e.target.selectionStart,
                              });
                            }}
                          />
                          <div className="d-flex justify-content-end">
                            {values.content?.length}/
                            {poll
                              ? MAX_MARKDOWN_CHARACTERS_POLL
                              : MAX_MARKDOWN_CHARACTERS_POST}
                          </div>
                          {touched.content && errors.content ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.content}
                              </div>
                            </div>
                          ) : null}
                        </Form.Group>
                        {showHashtag && suggestedHashtags.length > 0 ? (
                          <div>{hashtagSuggestion}</div>
                        ) : null}
                        {writingMention && suggestedPeople.length > 0 ? (
                          <div>{mentionsSuggestions}</div>
                        ) : null}

                        {(fetchPost && !fetchPost.published_at) ||
                        !fetchPost ? (
                          <Form.Group controlId="customNotification">
                            <div className="d-flex justify-content-start align-items-center mb-2">
                              <Form.Label>Custom push notification</Form.Label>
                              <div className="d-flex justify-content-between mb-2">
                                <div className="EmojiPicker ml-4 mr-4">
                                  <span
                                    onClick={() => setShowNotif(!showNotif)}
                                    className="svg-icon"
                                  >
                                    <SVG
                                      height="40"
                                      src={toAbsoluteUrl(
                                        "/media/svg/Emoticon.svg"
                                      )}
                                    />
                                  </span>
                                  {showNotif && (
                                    <div
                                      onMouseLeave={() => {
                                        if (showNotif) {
                                          setShowNotif(false);
                                        }
                                      }}
                                      ref={refPickerEmojiNotif}
                                      className="EmojiPicker__Wrapper"
                                    >
                                      <Picker
                                        onEmojiClick={onEmojiClickNotif}
                                        native
                                      />
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <textarea
                              style={{
                                width: "100%",
                                height: 100,
                                padding: 10,
                              }}
                              className="border"
                              type="text"
                              maxLength={MAX_MARKDOWN_CHARACTERS_NOTIFICATION}
                              placeholder="Here goes the content of your notification"
                              value={values.custonnotification}
                              onChange={(e) => {
                                setFieldValue(
                                  "custonnotification",
                                  e.target.value
                                );
                              }}
                            />
                            <div className="d-flex justify-content-end">
                              {values.custonnotification?.length}/
                              {MAX_MARKDOWN_CHARACTERS_NOTIFICATION}
                            </div>
                          </Form.Group>
                        ) : null}
                      </Card.Body>
                    </Card>
                  </div>
                  <div className="ml-5 w-25">
                    <Card>
                      <Card.Body>
                        <Form.Group controlId="pinnedPost">
                          <Form.Check
                            type="checkbox"
                            label=" Set post as 'Pinned'"
                            name="pinnedPost"
                            onChange={() => setPinnedPost(!pinnedPost)}
                            checked={pinnedPost}
                          />
                        </Form.Group>
                        <Form.Group controlId="formCategory">
                          <Form.Label>Attached to</Form.Label>

                          <Form.Control
                            as="select"
                            name="category"                            
                            onChange={handleChange}
                            value={values.category}
                            {...getFieldProps("category")}
                          >
                            {!values.category && <option>Category</option>}
                            {categoriesList.map((category) => (
                              <option key={category.id} value={category.id}>
                                {category.name}
                              </option>
                            ))}
                          </Form.Control>
                          {touched.category && errors.category ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.category}
                              </div>
                            </div>
                          ) : null}
                        </Form.Group>
                        <Form.Group controlId="formMediaContent">
                          <Form.Label>Media</Form.Label>
                          <Form.Control
                            as="select"
                            name="mediaContent"
                            disabled={fetchPost && fetchPost?.poll}                            
                            onChange={handleChange}
                            value={values.mediaContent}
                            {...getFieldProps("mediaContent")}
                          >
                            {mediaType.map((media, index) => {
                              if (
                                fetchPost &&
                                !fetchPost.poll &&
                                media !== "Poll"
                              ) {
                                return (
                                  <option key={index} value={media}>
                                    {media}
                                  </option>
                                );
                              } else if (!fetchPost) {
                                return (
                                  <option key={index} value={media}>
                                    {media}
                                  </option>
                                );
                              }
                              if (
                                fetchPost &&
                                fetchPost.poll &&
                                media == "Poll"
                              ) {
                                return (
                                  <option key={index} value={media}>
                                    {media}
                                  </option>
                                );
                              }
                            })}
                          </Form.Control>
                          {touched.mediaContent && errors.mediaContent ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {errors.category}
                              </div>
                            </div>
                          ) : null}
                          <span className="mb-2">
                            Only one media type allowed per post
                          </span>
                        </Form.Group>
                        {values.mediaContent == "Gif" && !extraGif && (
                          <div className="d-flex justify-content-center">
                            <Button onClick={postsUIEvents.openSelecGifDialog}>
                              Select Gif
                            </Button>
                          </div>
                        )}
                        {extraGif && (
                          <>
                            <div className="d-flex justify-content-center align-content-center align-self-center align-items-center mt-5 ml-5 mr-5 mb-5">
                              <img
                                className="d-flex justify-content-center align-content-center align-self-center"
                                src={extraGif.url}
                                width={200}
                              />
                            </div>
                            <div className="d-flex justify-content-center">
                              <Button onClick={() => onDeleteGif()}>
                                Remove Gif
                              </Button>
                            </div>
                          </>
                        )}
                        {values.mediaContent == "Images" && (
                          
                          <Form.Group controlId="formExtraImage">
                            <Form.Label>
                              Attach an image {extraImage?.length}/10
                            </Form.Label>
                            <Form.File
                              type="file"
                              name="extraImage"
                              onChange={onExtraImageChange}
                              label="Select an image"
                              custom
                              className="mb-0"
                            />
                            <small className="mt-3 d-inline-block text-primary">Images will be displayed in the order they are uploaded</small>
                            {extraImage?.length > 0 &&
                              showImagePreview(extraImage)}                            
                          </Form.Group>                         
                          
                        )}
                        {values.mediaContent == "Video" && (
                          <Form.Group controlId="formExtraVideo">
                            <Form.Label>Attach a video</Form.Label>
                            <Form.File
                              type="file"
                              name="extraVideo"
                              onChange={onExtraVideoChange}
                              label="Select a video"
                              custom
                            />
                          </Form.Group>
                        )}
                        {extraVideo && showVideoPreview(extraVideo)}
                        {values.mediaContent == "Poll" && (
                          <>
                            <div className="d-flex justify-content-center mb-2">
                              <div className="mr-2">
                                <Button
                                  onClick={postsUIEvents.openPollCreatorDialog}
                                >
                                  {!poll ? "Create Poll" : "Edit Poll"}
                                </Button>
                              </div>
                              <div>
                                {poll && !fetchPost && (
                                  <Button onClick={() => {
                                    dispatch(actions.postPollCreated({ poll: undefined }));
                                  }}>
                                    Remove Poll
                                  </Button>
                                )}
                              </div>
                            </div>
                            <div className="mt-4 d-flex justify-content-center mb-5">
                              {poll && <div>{poll.body}</div>}
                            </div>
                          </>
                        )}
                        {(fetchPost && !fetchPost.published_at) ||
                        !fetchPost ? (
                          <Form.Group controlId="formSchedule">
                            <Form.Label>Schedule</Form.Label>
                            <InputGroup className="mb-3">
                              <Form.Control
                                disabled
                                type="text"
                                name="category"
                                readOnly
                                value={dateLabel}
                                {...getFieldProps("schedulepost")}
                                placeholder={!dateLabel ? "Set" : dateLabel}
                              />
                              <div className="mb-2">
                                <Button
                                  className="btn btn-icon btn-primary"
                                  variant={"primary"}
                                  onClick={postsUIEvents.openSchedulePostDialog}
                                >
                                  <span className="svg-icon svg-icon-md">
                                    <SVG
                                      height="50"
                                      src={toAbsoluteUrl(
                                        "/media/svg/icons/Home/Timer.svg"
                                      )}
                                    />
                                  </span>
                                </Button>
                              </div>
                            </InputGroup>
                            <p>{dateLabelLocal}</p>
                            <p>{dateLabelUTC}</p>
                            {schedule && (
                              <div className="d-flex justify-content-center">
                                <Button
                                  onClick={() => {
                                    setSchedule();
                                    setDateLabel();
                                    setDatePostToSend();
                                    setDateLabelLocal();
                                    setDateLabelUTC();
                                  }}
                                >
                                  Clear
                                </Button>
                              </div>
                            )}
                          </Form.Group>
                        ) : null}
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              </Form>
            </>
          );
        }}
      </Formik>
    </>
  );
}
